import {
    AttachmentInfo,
    AttachmentProps,
    AttachmentToolbarProps,
    UploadConfig,
} from '@src/slide/domain/ui-model/element-modeles/property/attachment/interface';
import { JSXElementConstructor } from 'react';

export interface FileType {
    video?: Array<string>;
    audio?: Array<string>;
    image?: Array<string>;
    doc?: Array<string>;
    zip?: Array<string>;
}

/**
 * 上传准备状态的回调接口
 */
export interface AttachmentUploadListener {
    /**
     * 上传组件加载完成回调
     */
    onUpLoaderInit?();

    /**
     * 上传触发选择文件之后的回调
     * @param infos 选择文件之后返回的附件信息
     */
    onUploadWithFiles?(infos: AttachmentInfo[]);

    /**
     * 上传状态变更回调
     * @param opt 选择文件之后返回的附件信息
     */
    onStatusChanges?(opt: IStatusChangeOptions);
}

export interface AttachmentUploadInterface {
    /**
     * 触发上传
     */
    upload(options?: { acceptFileType?: FileType, inputConfig?: { file: File } });

    /**
     * 重新上传
     */
    reUploadAttachment(attachmentId: string);

    /**
     * 显示loading ui
     * @param id 附件上传id
     * @param container dom容器
     * @param options
     */
    showAttachment(id: string, container: HTMLElement, options?: AttachmentInfo): void;

    /**
     * 展示模态框
     * @param config
     */
    showExportModal(config: IExportModalOptions): void;

    /**
     * 删除指定id附件
     * @param id
     */
    removeAttachment(id: string): void;

    /**
     * 暂停上传
     * @param id
     */
    pauseAttachment(id: string): void; // 暂停上传

    /**
     * 继续上传
     * @param id
     */
    resumeAttachment(id: string): void; // 继续上传

    /**
     * 强制中断上传
     * @param id
     */
    abortUpload(id: string);

    /**
     * 取附件上传组件，成功之后的状态
     */
    getAttachmentComponent(): JSXElementConstructor<AttachmentProps>;

    /**
     * 获取附件的工具栏组件
     */
    getToolbarComponent(): JSXElementConstructor<AttachmentToolbarProps>;

    /**
     * 预览查看附件
     * @param attachmentInfo
     * @param padId
     */
    viewAttachmentInfo(attachmentInfo: AttachmentInfo, padId: string, options?: { onFullScreenChange: AttachmentProps['onFullScreenChange'] }): Promise<any> // 查看附件

    /**
     * 通过附件objKey，下载附件
     * @param objKey
     * @param attachmentId
     */
    download(objKey: string, attachmentId?: string);
}

export interface AttachmentComponentInterface extends AttachmentUploadInterface{
    /**
     * 挂载
     * @param config
     */
    mount(config: UploadConfig);

    /**
     * 上传状态回调
     * @param fn
     */
    onStatusChange(fn: (opt: IStatusChangeOptions) => void);


    /**
     * 获取附件
     * @param params
     * @param options
     */
    getDriveFile(params: { padId: string, objKey: string }, options?: { incrementalConfig?: any }): Promise<any>

    /**
     * 获取附件缩略图
     * @param params
     */
    getMediaPoster(params: { fileId: string, objKey: string }): Promise<any>
}

export interface IStatusChangeOptions {
    statusName: EStatusEvents;
    options?: any;
}

export interface IExportModalOptions {
    category: 'doc' | 'sheet' | 'slide';
    onOk?: () => void;
    onClickAction?: () => void;
}

export enum EStatusEvents {
    SUCCESS = 'success',
    ERROR = 'error',
    PROCESS = 'process',
    FILEREAD = 'fileRead',
}
